import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const Usuarios = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/usuario/new' || path.indexOf('/usuario/edit') === 0) && <Formulario {...props}/>}
            {path === '/usuario/list' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default Usuarios;
